/**
 * Offline Services
 *
 * 오프라인 지원을 위한 서비스 모듈
 */

export * from './indexedDB';
export * from './syncService';
export * from './registerSW';

// 오프라인 서비스 초기화
import { registerServiceWorker, type SWRegistrationConfig } from './registerSW';
import { initSyncService } from './syncService';

let initialized = false;

/**
 * 오프라인 서비스 초기화
 *
 * 앱 시작 시 호출하여 Service Worker 등록 및 동기화 서비스 초기화
 */
export async function initOfflineServices(config?: SWRegistrationConfig): Promise<void> {
  if (initialized) return;

  // Service Worker 등록
  await registerServiceWorker({
    onSuccess: (registration) => {
      config?.onSuccess?.(registration);
    },
    onUpdate: (registration) => {
      config?.onUpdate?.(registration);
    },
    onError: (error) => {
      console.error('Service Worker registration failed:', error);
      config?.onError?.(error);
    },
  });

  // 동기화 서비스 초기화
  initSyncService();

  initialized = true;
}

export default {
  initOfflineServices,
};
